/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbPaysGridDto } from './FcbPaysGridDto';
import {
    FcbPaysGridDtoFromJSON,
    FcbPaysGridDtoFromJSONTyped,
    FcbPaysGridDtoToJSON,
} from './FcbPaysGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbPaysGridDtoPaginatedResults
 */
export interface FcbPaysGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbPaysGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbPaysGridDto>}
     * @memberof FcbPaysGridDtoPaginatedResults
     */
    results?: Array<FcbPaysGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbPaysGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbPaysGridDtoPaginatedResults interface.
 */
export function instanceOfFcbPaysGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbPaysGridDtoPaginatedResultsFromJSON(json: any): FcbPaysGridDtoPaginatedResults {
    return FcbPaysGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbPaysGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbPaysGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbPaysGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbPaysGridDtoPaginatedResultsToJSON(value?: FcbPaysGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbPaysGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

